export enum Shova52DealtTo {
    PLAYER = 'player',
    DEALER = 'dealer',
}
